module.exports = __webpack_public_path__ + "b3fd5b17b2c1070ca61a1cf2b088ad8b.svg";